
export const FIREBASE = {
    USERS_COllECTION: "users"
}